/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export class DeepSet extends Set {
  add(o: any): this {
    for (const i of this) {
      if (this.deepCompare(o, i)) {
        return this;
      }
    }
    super.add.call(this, o);
    return this;
  }

  private deepCompare(o: any, i: any) {
    return JSON.stringify(o) === JSON.stringify(i);
  }
}
